/**
 * 빌드 환경 여부
 */
export const IS_PRODUCTION_ENV = process.env.NODE_ENV === 'production' && process.env.RUN_MODE !== 'local';
